import { render, staticRenderFns } from "./TopicTable.vue?vue&type=template&id=14f7cd14&scoped=true&"
import script from "./TopicTable.vue?vue&type=script&lang=js&"
export * from "./TopicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f7cd14",
  null
  
)

export default component.exports